import { MappedNotification } from 'common/header/notifications/Notifications.types';
import { getNotificationState } from 'common/header/notifications/hooks/Notification.utils';
import { NotificationIntlMessages } from 'src/components/common/header/translations/useNotificationsIntl';

export const getWorkdayOrgSyncTreeTitle = (
  notificationViewModel: Partial<MappedNotification>,
  intl: NotificationIntlMessages
) => {
  const state = getNotificationState(notificationViewModel.status);
  let title = notificationViewModel?.title ?? '';
  let description = notificationViewModel?.description ?? '';
  if (state.isReady) {
    description = intl.workdaySuccessDescription;
  } else if (state.inProgress) {
    description = intl.workdayInProgressDescription;
  } else {
    description = state.isError ? intl.workdayFailureDescription : '';
  }
  title = intl.workdayTitle;
  return { title, description };
};
